module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-School",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21.2857143,22.3602213 L21.2857143,13.3333333 L35.1927179,5 L48.7142857,13.3333333 L48.7142857,22.3182013 L65,22.3182013 L65,55 L41.0359933,55 L41.0343192,37.5360107 L29.0006278,37.5360107 L29.0006278,55 L5,55 L5,22.3602213 L21.2857143,22.3602213 Z M35,26.6666667 C38.3137085,26.6666667 41,24.0549944 41,20.8333333 C41,17.6116723 38.3137085,15 35,15 C31.6862915,15 29,17.6116723 29,20.8333333 C29,24.0549944 31.6862915,26.6666667 35,26.6666667 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d25c5f7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/school.vue
// module id = 640
// module chunks = 1